<div class="row">
  <div class="col-12">
    <h2 id="propertiesTransferred">Informations sur les sociétés rattachées</h2>

    @for (connectedCorporationForm of this.connectedCorporations.formGroups; track connectedCorporationForm; let i = $index) {
      <div class="card">
        <div class="row card-body">
          <div class="row d-flex justify-content-between">
            <div class="d-flex" style="width: fit-content">
              <h3 [id]="'dividend-received-' + (i+1)">Dividendes reçus de société rattachée #{{ i + 1 }}</h3>
            </div>
            <div class="dropdown d-flex" style="width: fit-content">
              <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle" data-bs-toggle="dropdown"
                data-expanded="false" href="#" role="button">
                <i class="fe fe-more-vertical"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end">
                <a (click)="removeChildren(i); $event.preventDefault()" class="dropdown-item"
                  href="#">
                  Supprimer
                </a>
              </div>
            </div>
          </div>
          <app-salary-dividend-corporate-tax-connected-corporation-form
            [connectedCorporationForm]="connectedCorporationForm"
            [form]="this.form"
            [index]="i"
            #property
          ></app-salary-dividend-corporate-tax-connected-corporation-form>
        </div>
      </div>
    }

    <div class="card">
      <a (click)="this.addConnectedCorporation(); $event.preventDefault()" class="card-body"
        href="#propertiesTransferred"
        id="add_property_transferred">
        + Ajouter une société rattachée
      </a>
    </div>

  </div>
</div>